import {serializable, alias, primitive, list, object} from 'serializr';
import {ClassRoomSubjectModel} from "../CourseModels/SubjectModel/subject.model";

export class TutorModel {
    @serializable(alias('id', primitive()))
    id?: string;
    @serializable(alias('email', primitive()))
    email?: string;
    @serializable(alias('first_name', primitive()))
    firstName?: string;
    @serializable(alias('last_name', primitive()))
    lastName?: string;
    @serializable(alias('phone_number', primitive()))
    phoneNumber?: string;
    @serializable(alias('full_name', primitive()))
    fullName?: string;
    @serializable(alias('date_of_birth', primitive()))
    dateOfBirth?: string;
    @serializable(alias('qualification', primitive()))
    qualification?: string;
    @serializable(alias('display_picture_url', primitive()))
    displayPictureUrl?: string;
    @serializable(alias('gender', primitive()))
    gender?: string;
    @serializable(alias('is_active', primitive()))
    isActive?: boolean;
    @serializable(alias('password', primitive()))
    password?: boolean;
    @serializable(alias('tutor_subjects', list(object(ClassRoomSubjectModel))))
    tutorSubjects?: boolean;
}

class ClassroomSubjectMetaModel{
    @serializable(alias('id', primitive()))
    id?: string;
    @serializable(alias('subject_name', primitive()))
    name?: string;
}

class ClassroomMetaModel{
    @serializable(alias('id', primitive()))
    id?: string;
    @serializable(alias('name', primitive()))
    name?: string;
    @serializable(alias('class_room_subjects', list(object(ClassroomSubjectMetaModel))))
    classroomSubjects?: any;
}

export class BoardMetaModel{
    @serializable(alias('id', primitive()))
    id?: string;
    @serializable(alias('name', primitive()))
    name?: string;
    @serializable(alias('acronym', primitive()))
    acronym?: string;
    @serializable(alias('class_rooms', list(object(ClassroomMetaModel))))
    classrooms?: any;
}
